export default {
  GenderFormField__FEMALE: "Female",
  GenderFormField__GENDER: "Gender",
  GenderFormField__MALE: "Male",
  GenderFormField__SELECT: "Select",
};
